import block_icons from '../icons/icon_list';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InnerBlocks, RichText, InspectorControls, MediaUpload, MediaUploadCheck } = wp.editor;
const { PanelBody, PanelRow, SelectControl, TextControl, Card, CardBody, Dashicon,
    ToggleControl, Button, RangeControl, TabPanel, ColorPalette, ColorIndicator } = wp.components;


registerBlockType('blocksbakery/icon-list-child', {
    title: __("Icon List", "blocks-bakery"),
    description: __(" This block is used to create a list with image or icons shown as bullets for each list item.", "blocks-bakery"),
    icon: block_icons.flat_icon,
    category: 'blocks-bakery',
    keywords: [
        __( 'icon', 'blocks-bakery' ),
        __( 'list', 'blocks-bakery' ),
        __('label','blocks-bakery')
    ],

    edit: (props) => {
        return [
            <InnerBlocks
                allowedBlocks={['blocksbakery/icon-list']}
                template={[
                    ['blocksbakery/icon-list'],
                ]}
            />
        ]
    },

    save: (props) => {
        return (
            <div>
            <InnerBlocks.Content />
            </div>
        )
    },

})